"use client"

import { useState, useEffect } from "react"
import "./carousel.css"

interface MovingCarouselProps {
  setBackgroundColor: (color: string) => void;
  initialColor?: string;
}

export default function MovingCarousel({ setBackgroundColor, initialColor = "#ccfbf1" }: MovingCarouselProps) {
  // Color options available in the carousel
  const colors = [
    "#fee2e2", // Red
    "#ffedd5", // Orange
    "#fef9c3", // Yellow
    "#ecfccb", // Lime
    "#dcfce7", // Green
    "#ccfbf1", // Teal
    "#dbeafe", // Blue
    "#ede9fe", // Purple
    "#fae8ff", // Pink
    "#ffe4e6", // Rose
  ];

  const [selectedColor, setSelectedColor] = useState<string>(initialColor);

  // Set initial color when component mounts
  useEffect(() => {
    // Устанавливаем выбранный цвет и цвет фона
    setSelectedColor(initialColor);
    setBackgroundColor(initialColor);
    
    // Устанавливаем цвет фона для карусели
    const carouselElement = document.querySelector('.banner') as HTMLElement;
    if (carouselElement) {
      carouselElement.style.backgroundColor = initialColor;
    }
  }, [initialColor, setBackgroundColor]);

  // Function to handle card click
  const handleColorClick = (color: string) => {
    setSelectedColor(color);
    setBackgroundColor(color);
    
    // Простое изменение фона карусели без градиента
    const carouselElement = document.querySelector('.banner') as HTMLElement;
    if (carouselElement) {
      carouselElement.style.backgroundColor = color;
    }
  }

  return (
    <div className="banner" style={{ backgroundColor: initialColor }}>
      {/* Carousel of color cards */}
      <div className="slider" style={{ "--quantity": "10" } as React.CSSProperties}>
        {colors.map((color, index) => (
          <div 
            key={color} 
            className="item" 
            style={{ "--position": index + 1 } as React.CSSProperties}
          >
            <div
              className={`color-card ${selectedColor === color ? 'selected' : ''}`}
              style={{ backgroundColor: color }}
              onClick={() => handleColorClick(color)}
            ></div>
          </div>
        ))}
      </div>
    </div>
  )
}

